import React from 'react';
import './EditProfile.css';

import { PageTitle } from '../../../../components';

const EditProfile = () => {

  const handleSubmit = (event) => {
    event.preventDefault(); // Prevent the default form submission behavior
    // Reset the form fields
    event.target.reset();
  };

  return (
    <>
      {/* Page Title - Update the title and page props as needed */}
      <PageTitle title={'edit profile'} page={'edit profile'} />

      <section className='edit-profile'>
        {/* Edit Profile Form */}
        <form className='account-form' onSubmit={handleSubmit}>
          <h3>edit profile</h3>
          <input type="text" name="name" placeholder="full name" id="name" className='box' />
          <input type="email" name="email" placeholder="email address" id="email" className='box' />
          <input type="text" name="number" placeholder="phone number" id="number" className='box' />
          <input type="file" name="profile-pic" id="profile-pic" accept="image/*" className='box' />
          <button type="submit" className='btn' name="edit-profile" id="edit-profile">edit profile</button>
        </form>
      </section> 
    </> 
  );
}

export default EditProfile;